export default "__VITE_ASSET__BNGKd0Jn__"